export const SIGN_IN = '/sign-in';
export const DASHBOARD = '/dashboard';
